import React from 'react';
import styled from 'styled-components';

import Media from './media';
import EventCard from './eventCard';

const BasicInfoWrapper = styled.div`
	display: flex;
	flex-direction: column;

	@media ${props => props.theme.device.lgDesktop} {
		flex-direction: row;
	}

	@media ${props => props.theme.device.desktop} {
		flex-direction: row;
	}
`;

const BasicInfo = (): JSX.Element => (
	<BasicInfoWrapper>
		<Media />
		<EventCard />
	</BasicInfoWrapper>
);

export default BasicInfo;
